export default __webpack_public_path__ + "static/media/peciatka.73a67932.jpg";